import React, { useState } from 'react'
import { Icon, Modal, Popover, Checkbox } from "antd"
import * as applyBrandingForAllItems from "../../../configs/applyBrandingForAllItems"

function MarkPackagedPageDetails(props) {
    const { loading, processingOrder, totalItems, orders = [], reset, onMarkPackaged, onCancel, combineShipData, sku = {} } = props
    const { brand, brandKit, thankCard, barcode = {}, meta = {} } = processingOrder || {}
    const { set_items = [] } = meta || {}
    const setItemOptons = Array.isArray(set_items) && !!set_items.length ? set_items.map((i) => ({
        label: <span style={{ fontWeight: 700, fontSize: 20 }}>{i.name}</span>,
        value: i._id,
    })) : []
    const { tags = [] } = { ...barcode }
    const [hoverOrder, setHoverOrderState] = useState(false)
    const [visibleImage, setVisibleImage] = useState(null)
    const [imageName, setImageName] = useState('')
    const [itemsSetSelected, setItemsSetSelected] = useState([])
    const [checkedAllSetItems, setCheckedAllSetItems] = useState(false)

    const isAppliedBrandingForAllItems = applyBrandingForAllItems.isSupport(processingOrder && processingOrder.barcode)
    const isThankCard = () => !!(thankCard && thankCard.length)
    const isBrandKit = () => !!(brandKit && brandKit.length)
    const isMadeInVN = tags.includes('made_vn')
    const isNoProofTag = tags.includes('no_proof')
    const { is_cheap_product = false } = sku || {}
    const disabledBtnMark = (Array.isArray(set_items) && set_items.length ? !checkedAllSetItems : false)

    const maxCols = ({
        1: 12,
        2: 6,
        3: 4
    })[totalItems] || 4

    const handleMarkPackaged = () => {
        onMarkPackaged()
        // const modal = Modal.confirm({
        //     title: 'Thông báo',
        //     content: <>Bạn chắc chắn muốn đánh dấu
        //         đơn <strong>{getBarcodeString()}</strong> đã đóng gói?</>,
        //     onOk: () => {
        //         onMarkPackaged()
        //         modal.destroy()
        //     },
        //     okText: 'Tiếp tục',
        //     cancelText: 'Hủy',
        //     onCancel
        // })
    }

    const handleShowModal = (image, name) => {
        setVisibleImage(image)
        setImageName(name)
    }

    const handleHideModal = () => {
        setVisibleImage(null)
        setImageName('')
    }

    const setHoverOrder = (order, visible) => () => visible

    const getPreviewImageContent = (order) => {
        return <img src={order.preview_image} key={order._id} alt='preview' />
    }

    const PreviewImage = (props) => {
        const {
            order,
            placement = 'left',
        } = props

        return <div
            className={[
                'PreviewPrinting',
                // 'position-relative',
                // 'ImagePreview'
            ].filter(Boolean).join(' ')} key={order._id}
            onMouseEnter={setHoverOrder(order, true)}
            onMouseOut={setHoverOrder(order, false)}
        >
            <Popover content={getPreviewImageContent(order)}
                placement={placement}
                trigger="hover"
                key={order._id}>
                <img
                    src={order.preview_image}
                    alt='preview'
                    style={{
                        width: '100%',
                        height: 540,
                        objectFit: 'cover'
                    }}
                />
            </Popover>
            {/* <div className='Actions d-flex justify-content-center align-items-center position-absolute'>
                <span className='Icon cursor-pointer mr-2' onClick={() => handleShowModal(order.preview_image, '')}><Icon type='eye' /></span>
            </div> */}
        </div>
    }

    const ThankCardBlock = () => {
        return <>
            {
                thankCard.map(order => {
                    return (
                        <div className="Block ThankCardBlock position-relative" key={order._id}>
                            <div className="d-flex justify-content-between">
                                <div className="ColContent">
                                    <div className={['PreviewPrinting'].filter(Boolean).join(' ')}>
                                        <PreviewImage order={order} placement="topRight" />
                                    </div>
                                </div>
                            </div>
                            <div className="font-weight-bold position-absolute" style={{ top: '-25px', right: 0, color: 'black' }}>Thank card</div>
                        </div>
                    )
                })
            }
        </>
    }

    const BrandKitBlock = () => {
        const bkItems = isAppliedBrandingForAllItems ? [brandKit[0]] : brandKit

        return <>
            {
                bkItems.map(order => {
                    return (
                        <div className="Block BrandKitBlock position-relative" key={order._id}>
                            <div className="row">
                                <div className="col-md-12 ColContent">
                                    <PreviewImage order={order} />
                                </div>
                            </div>
                            <div className="font-weight-bold position-absolute" style={{ top: '-25px', right: 0, color: 'black' }}>Brand kit</div>
                        </div>
                    )
                })
            }
        </>
    }

    const handleCheckSetItems = (checkedValues) => {
        setItemsSetSelected(checkedValues)
        setCheckedAllSetItems(Array.isArray(set_items) ? checkedValues.length === set_items.length : false)
    }

    return (
        <div className="MarkPackagedPageDetails">
            <div className="BasicInfo d-flex flex-wrap justify-content-between mt-2 mb-2">
                <div className="leftContent">
                    <span className="InfoType">{processingOrder.type}</span>
                    <span className="InfoSize badge bg-secondary">{processingOrder.size}</span>
                    <span className="InfoSize badge bg-secondary">{processingOrder.color}</span>
                    <span className="InfoSize badge bg-secondary">{!!processingOrder.designBack && "Back"}</span>
                    <span className="InfoSize badge bg-secondary">{!!processingOrder.designFront && "Front"}</span>
                    <span className="InfoSize badge bg-secondary">{!!processingOrder.designHood && "Hood"}</span>
                    <span className="InfoSize badge bg-secondary">{!!processingOrder.designSleeves && "Sleeves"}</span>
                    <span className="InfoSize badge bg-secondary">{processingOrder.item_number}</span>
                    {
                        brand && brand.name && <span className="InfoBrand badge text-bg-danger">{brand.name}</span>
                    }
                    {
                        tags.includes('combo_fac') && <span className="InfoBrand badge text-bg-danger">COMBO_FAC</span>
                    }
                    {!!is_cheap_product &&
                        <span className="InfoBrand badge text-bg-danger">SP giá rẻ</span>
                    }
                    <p><strong>{totalItems}</strong> đơn cần đánh dấu</p>
                </div>
                <div className="rightContent d-flex flex-wrap">
                    {isNoProofTag &&
                        <span className='mb-2 mx-2' style={{
                            color: 'red',
                            border: '2px solid red',
                            padding: '2px 10px',
                            fontWeight: 'bold',
                            borderRadius: 5,
                            fontSize: 20,
                            display: 'block',
                            height: 37,
                        }}>No TAG cảnh báo</span>
                    }
                    {isMadeInVN &&
                        <span className='mb-2 tagVN'>Made in VN</span>
                    }
                </div>
            </div>
            <div className={['ListOrders', 'row'].join(' ')}>
                {
                    orders.map(order => {
                        const { image, preview_image, procedure, designFront, designBack, designLeft, designRight, designHood, designSleeves } = order
                        const arrPrintFileImg = [
                            { name: 'Front', image: designFront },
                            { name: 'Back', image: designBack },
                            { name: 'Left', image: designLeft },
                            { name: 'Right', image: designRight },
                            { name: 'Sleeves', image: designSleeves },
                            { name: 'Hood', image: designHood },
                        ].filter(item => item.image)

                        return (
                            <>
                                {procedure === '2D' ? (
                                    <div className={`Order mb-4 col-md-${maxCols} d-flex flex-wrap`} key={order._id}>
                                        {arrPrintFileImg.length > 0 && arrPrintFileImg.map((item, index) => (
                                            <div key={`printFileImg_${index}`} className="OrderInner" style={arrPrintFileImg.length > 1 ? { width: '50%', padding: 10, background: 'white', zIndex: 11 } : { width: '100%' }}>
                                                <div
                                                    className="ImagePreview position-relative h-100"
                                                    key={`${order._id}_${index}`}
                                                >
                                                    <h3>{item.name}:</h3>
                                                    <img src={item.image} className='previewImage' alt='preview' />
                                                    <div className='Actions d-flex justify-content-center align-items-center position-absolute'>
                                                        <span className='Icon cursor-pointer mr-2' onClick={() => handleShowModal(item.image, item.name)}><Icon type='eye' /></span>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (
                                    <React.Fragment>
                                        <div className={`Order mb-4 ${(isThankCard() || isBrandKit()) ? 'col-md-8' : 'col-md-12'} pr-0`} key={order._id}>
                                            <div className="OrderInner">
                                                {
                                                    preview_image && <div className="ImagePreview position-relative">
                                                        <img src={preview_image} className='previewImage' alt='preview' />
                                                        <div className='Actions d-flex justify-content-center align-items-center position-absolute'>
                                                            <span className='Icon cursor-pointer mr-2' onClick={() => handleShowModal(preview_image, '')}><Icon type='eye' /></span>
                                                        </div>
                                                        <div className="font-weight-bold position-absolute" style={{ top: '-25px', right: 0, color: 'black' }}>File print</div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        {(isThankCard() || isBrandKit()) && <div className="mb-4 col-md-4">
                                            <div className="OrderInner border-left-0">
                                                <div className="ImagePreview position-relative">
                                                    {
                                                        isThankCard() && <ThankCardBlock />
                                                    }

                                                    {
                                                        isBrandKit() && <>
                                                            <BrandKitBlock />
                                                            {
                                                                isAppliedBrandingForAllItems &&
                                                                <p className="alert alert-danger mb-0">Đóng gói 1 item / 1 túi zip/ 1 BrandKit</p>
                                                            }
                                                        </>
                                                    }
                                                </div>
                                            </div>
                                        </div>}
                                    </React.Fragment>
                                )}
                            </>
                        )
                    })
                }
            </div>
            <Modal
                visible={!!visibleImage}
                closable={false}
                centered={true}
                footer={null}
                width={1200}
                onCancel={handleHideModal}
            >
                <div className="Previewer">
                    {imageName && <h3>{imageName}:</h3>}
                    {visibleImage && <img src={visibleImage} alt='preview' className='d-block m-auto' />}
                </div>
            </Modal>
            <div className="Actions d-flex justify-content-between align-items-center mb-4">
                <div className="btnCancel">
                    <button type="button" className="btn btn-secondary" onClick={reset}>Hủy</button>
                </div>
                <div className="d-flex align-items-center">
                    <div className="listSetItems mx-3">
                        <div className="item">
                            <Checkbox.Group
                                options={setItemOptons}
                                value={itemsSetSelected}
                                onChange={handleCheckSetItems}
                            />

                        </div>
                    </div>
                    <div className="btnMarkPackaged">
                        <button
                            type="button"
                            className="btn btn-primary Mark"
                            onClick={handleMarkPackaged}
                            disabled={disabledBtnMark}
                        >
                            Đánh dấu đóng gói
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default MarkPackagedPageDetails